/** */
export const formatMonth = (ym) => {
  const [year, month] = ym.split('-');
  const label = new Date(Number(year), Number(month) - 1).toLocaleString('en-GB', {
    month: 'short'
  });
  return `${label} '${year.slice(2)}`;
};
